/**
 * Updates the recently viewed products in localStorage.
 */

export class RecentlyViewed {
	/** @static @constant {string} The key used to store the viewed products in session storage */
	static #STORAGE_KEY = "viewedProducts";
	/** @static @constant {number} The maximum number of products to store */
	static #MAX_PRODUCTS = 4;

	/**
	 * Adds a product to the recently viewed products list.
	 * @param {string} productId - The ID of the product to add.
	 */
	static addProduct(productId) {
		let viewedProducts = RecentlyViewed.getProducts();

		viewedProducts = viewedProducts.filter((/** @type {string} */ id) => id !== productId);
		viewedProducts.unshift(productId);
		viewedProducts = viewedProducts.slice(0, RecentlyViewed.#MAX_PRODUCTS);

		localStorage.setItem(RecentlyViewed.#STORAGE_KEY, JSON.stringify(viewedProducts));
	}

	static clearProducts() {
		localStorage.removeItem(RecentlyViewed.#STORAGE_KEY);
	}

	/**
	 * Retrieves the list of recently viewed products from session storage.
	 * @returns {string[]} The list of viewed products.
	 */
	static getProducts() {
		return JSON.parse(localStorage.getItem(RecentlyViewed.#STORAGE_KEY) || "[]");
	}
}
